import { DataAttributeDefinitions } from 'scrivito'

import { pisaTimerecordDataClass } from './Pisa/pisaTimerecordDataClass'

const attributes: DataAttributeDefinitions = {}

export const Timerecord = pisaTimerecordDataClass(attributes)
